<template lang="html">
  <tr>
    <td class="column-id">
      {{ model.id }}
    </td>

    <td class="column-name" >
      <a @click="go_to_vacancy">{{ model.name}}</a>
    </td>

    <td class="column-date">
      {{ createdAt  }}
    </td>

    <td class="column-owner">
      {{ model.response_number }}
    </td>

    <td class="column-owner">
      {{ !this.is_japan_locale ? [model.user.name, model.user.surname].join(' ') : [model.user.surname, model.user.name].join(' ') }}
    </td>

    <td class="column-recruiters">
      {{ !this.is_japan_locale ? [model.user.name, model.user.surname].join(' ') : [model.user.surname, model.user.name].join(' ') }}
    </td>

    <td class="column-recruiters">
      <vacancy-modules
        :vacancyId="model.id"
        :modules="model.modules"
        :target="'_blank'"
      />
    </td>

    <td class="column-recruiters" >
      <vbutton
              v-if="model.deleted"
              :text="$tr('admin_console.company.vacancies.restore')"
              :disabled="restoringVacancy"
              :loading="restoringVacancy"
              @click="restoreVacancy(model.id) "/>
    </td>

  </tr>
</template>

<script>
  import Moment from 'moment'

  import { STORE_PREFIX } from '../constants.js';

  import VacancyModules from '@/components/vacancies/VacancyModules.vue'

  export default {
    name: 'vacancy-row',

    components: {
      VacancyModules
    },

    props: {
      companyId: null,
      model: Object,
      is_japan_locale: Boolean
    },

    data() {
      return {
        restoringVacancy: false,
      }
    },

    methods: {
      restoreVacancy(id) {
        this.restoringVacancy = true;
        this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/restoreOne',  {
          id: this.model.id
        })
        .then(() => {
          this.restoringVacancy = false;
          this.fetch_list()
        })
      },

      go_to_vacancy() {
        this.$router.push(this.vacancy_route())
      },

      fetch_list () {
        this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/fetch', {company_id: this.companyId})
      },

      auth () {
        if (!this.user) {
          throw Error
        }

        this.$store.dispatch(STORE_PREFIX + 'admin/authUser', this.user)
          // .then(() => this.$router.replace('/'))
          .then(() => { window.location = '/' })
      },

      vacancy_route() {
        return `/admin/company/${this.companyId}/vacancies/${this.model.id}`;
      }
    },

    computed: {
      createdAt () {
        return this.model.created_at
          ? Moment(this.model.created_at).format(this.dateFormat)
          : null
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

tr {
  height: 60px;
}

.user-select-box {
  display: flex;

  .select {
    list-style: none;
  }

  .button {
    margin-left: 3px;
    cursor: pointer;
    list-style: none;
    font-size: 14px;
    min-width: 34px;
    line-height: 34px;
    text-align: center;
    border: 1px solid #cccccc;
    border-radius: 3px;
  }
}

.logo-holder {
  width: 84px;
  height: 64px;
  position: relative;
  cursor: pointer;

  img {
    // display: none;
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.avatar-empty {
  background: #f0f0f0;
  text-align: center;
  width: 84px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 36px;
    max-width: 36px;
  }
}

.column-date {
  color: $grey-color;
}

.column-name {
  font-size: 1.1em;
}

.column-payment {
  color: $green;

  .not-paid {
    color: $red-color;
  }
}
</style>
